import { AmcJoiningInformationResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { PassAmcInformationModel } from './pass-amc-information.state';

/** StateDetailsActions */
const ACTION_SET = '[PassAmcInformation] set';
const ACTION_UPDATE = '[PassAmcInformation] update';
const ACTION_RESET = '[PassAmcInformation] reset';
const ACTION_FAIL = '[PassAmcInformation] fail';
const ACTION_CANCEL_REQUEST = '[PassAmcInformation] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[PassAmcInformation] set from api';
const ACTION_UPDATE_FROM_API = '[PassAmcInformation] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setPassAmcInformation = createAction(ACTION_SET, props<WithRequestId<PassAmcInformationModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updatePassAmcInformation = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<PassAmcInformationModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetPassAmcInformation = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelPassAmcInformationRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failPassAmcInformation = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setPassAmcInformationApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<AmcJoiningInformationResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updatePassAmcInformationApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<AmcJoiningInformationResponse>>()
);
